import React from 'react';
import { Box, type SxProps, type Theme } from '@mui/material';
import { panelDividerBg } from './panelDividerBg';

export interface VerticalResizeHandleProps {
  onMouseDown: (event: React.MouseEvent) => void;
  sx?: SxProps<Theme>;
}

const VerticalResizeHandle: React.FC<VerticalResizeHandleProps> = ({ onMouseDown, sx }) => (
  <Box
    role="separator"
    aria-orientation="vertical"
    aria-label="Resize panels"
    onMouseDown={onMouseDown}
    sx={{
      display: { xs: 'none', lg: 'flex' },
      alignItems: 'center',
      justifyContent: 'center',
      width: 10,
      flexShrink: 0,
      alignSelf: 'stretch',
      cursor: 'col-resize',
      position: 'relative',
      borderRadius: 1,
      transition: 'background 0.15s',
      '&:hover, &:active': { bgcolor: 'action.selected' },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '1px',
        bgcolor: panelDividerBg,
      },
      '&:hover::before, &:active::before': {
        bgcolor: 'primary.main',
        opacity: 0.65,
      },
      '& .drag-dots': { opacity: 0.35 },
      '&:hover .drag-dots, &:active .drag-dots': { opacity: 0.85 },
      ...sx,
    }}
  >
    <Box className="drag-dots" sx={{ display: 'flex', flexDirection: 'column', gap: '3px', zIndex: 1 }}>
      {[0, 1, 2, 3, 4].map((i) => (
        <Box
          key={i}
          sx={{ width: 3, height: 3, borderRadius: '50%', bgcolor: 'text.secondary' }}
        />
      ))}
    </Box>
  </Box>
);

export default VerticalResizeHandle;
